import { Spinner } from './admin-ui';
import './PageLoading.css';

export default function PageLoading({ label = 'Loading page', message, size = 'large' }) {
  return <div className="admin-page-loading">
    <Spinner accessibilityLabel={label} size={size} />
    {message ? <p>{message}</p> : null}
  </div>;
}
